module.exports = __webpack_public_path__ + "resource/img/bottom_logo.png?9cc1d4581a6d3b393a5edb5178ca69f8";


//////////////////
// WEBPACK FOOTER
// ./src/images/bottom_logo.png
// module id = 654
// module chunks = 0 2